const ACTIVITIES = [
    {
        date: "2023-06-14",
        title: "ChatGPT 在金融與企業之發展與應用論壇",
        intro: "ChatGPT 作為先進的自然語言處理技術，對金融科技與企業帶來了重大衝擊和廣泛應用，更加速了科技轉型的腳步。本論壇邀請 AI 領域、金融保險領域、AI 獨角獸企業、銀行業、國際級管理諮詢公司的專家學者進行演說與座談會交流，探討 ChatGPT 於現今金融科技和企業領域的潛在發展與創新應用，以及相應的影響、挑戰與未來的應對策略，期望匯聚各方專業人士分享經驗和見解，促進交流與合作，進而推動 AI 智慧發展應用。",
        place: "國立臺灣大學法律學院霖澤館",
        fileName: "0614金融中心論壇邀請函.jpg",
        pics: [
            "chatgpt論壇_pic1.jpg",
            "chatgpt論壇_pic2.jpg",
            "chatgpt論壇_pic3.jpg",
            "chatgpt論壇_pic4.jpg",
        ],
        paragraph: [
            "臺大金融科技研究中心與臺大國際產學聯盟於6月14日成功舉辦了以「ChatGPT在金融與企業之發展與應用」為主題的論壇活動。近兩百名專業人士參與了此次盛會，包括學者、業界專家和企業領袖，共同探討ChatGPT在金融和企業領域的潛能和挑戰。",
            "ChatGPT 自 2022 年底迅速崛起後引起了廣泛的關注和興趣，不僅對於金融科技和各企業領域具有重大意義，同時也在各行各業引發了革命性的影響。臺大金融科技研究中心主任陳祝嵩提到：「臺大金融中心舉辦本次論壇目的，就是希望趁著這波浪潮，集結專家學者各方觀點，帶來創新思考，促進ChatGPT原先基礎模型在企業界的應用，到了公司內部能再發展出專才的模型。」臺大研發長暨國際產學聯盟主任吳忠幟在開場致詞中指出：「AI 科技在過去十年有了驚人的發展，相對於其他 AI 技術的應用，ChatGPT 對一般使用者來說更加直接，感受也更為強烈。ChatGPT 創造了許多的機會，為使用者與企業提升了工作效率、加速數位轉型，但同時也帶來資安、倫理、法律等方面的考量與風險。新的科技需要新的因應，而這也正是我們籌畫本場論壇的起因。」",
            "論壇的前半場涵蓋了多個主題演講，臺大資訊工程學系陳縕儂副教授首先從近期生成式 AI與 過去的差異談起，分享了如何提升 ChatGPT 的使用經驗，以及如何預防例如資料外洩、資訊錯誤等技術困難。政治⼤學數位金融創新實驗室謝明華執行長則談及數位轉型對於組織的重要性，並分享了數個成功轉型的企業案例。接著，玉山金控張智星科技長探討了生成式 AI 目前在金融業的應用與面臨的痛點；沛星科技首席科學家林守德則從不同類型的企業角度，討論組織如何確認 AI 的應用範圍、導入流程以及成效評估。最後，麥肯錫亞洲資深顧問兼前花旗台灣商業銀行董事長管國霖則探討了 AI 如何從客戶的角度提供整合型、客製化的服務，並從經營者的角度優化成本效益、員工效能，進而成就以客戶為中心的智慧金融。",
            "此外，所有講者於演講後進行一場Panel Discussion座談會，由臺大金融科技研究中心陳祝嵩主任擔任主持人，與所有講者針對 ChatGPT 以及不同的 AI 技術在導入企業應用時的挑戰進行深入交流和討論，各講者分享了豐富的實務經驗和見解，並積極交換意見。本論壇成功展現了 AI 科技於金融與企業領域的無窮潛力，促進跨界合作與知識交流，同時也凸顯了科技研究與產業接軌的重要性。通過產學密切合作，臺灣大學期待讓本論壇的效益加乘，持續與學者、業界專家和企業領袖攜手合作，打造更多的創新應用和技術突破。",
            "主辦單位：臺大金融科技研究中心、臺大國際產學聯盟",
            "協辦單位：政大風險與保險研究中心",
        ],
    },
    {
        "date": "2023-08-01",
        "title": "Cognitive Tools for Uncovering Useful Abstractions",
        "intro": "本演講探討人類如何運用認知工具進行抽象概念的發現與應用，對於人工智慧理解與模仿人類思維模式具有啟發意義，呼應本中心推動 AI 與認知科學在金融科技決策與資料分析上的跨域應用。演講由來自史丹佛大學的 Judith Fan 教授主講，探討人類如何透過認知工具如繪圖與實體建構等方式，發現並運用有用的抽象概念，進而促進學習、溝通與創造。她的研究結合認知科學、計算神經科學與人工智慧等領域，致力於逆向工程人類的認知工具箱，並解析這些行為在 AI 與教育等實務領域的潛在應用。",
        "place": "臺大資工系 CSIE R104",
        "fileName": "0801_JudithFan_lecture.jpg",
        "pics": [
            // "judithfan_pic1.jpg",
            // "judithfan_pic2.jpg",
            // "judithfan_pic3.jpg",
            // "judithfan_pic4.jpg"
        ],
        "paragraph": [
            "2023 年 8 月 1 日，來自史丹佛大學的心理學助理教授 Judith Fan 蒞臨臺大，發表題為「Cognitive Tools for Uncovering Useful Abstractions」的演講，吸引眾多對認知科學與人工智慧應用有興趣的學者與學生參與。",
            "Fan 教授在演講中指出，從 17 世紀的笛卡兒座標系統開始，人類發明的認知工具不僅加速了科學發展，也擴展了我們抽象思考與解決問題的能力。她透過多項實證與計算模型研究，說明繪圖行為如何成為理解視覺世界、學習與溝通抽象概念的重要媒介。",
            "演講後半部，她介紹了研究團隊目前進行的另一項研究主題：人類在建構實體結構時如何發現並外化抽象概念以支援規劃與合作。這些自然、複雜的行為背後的心理機制，不僅豐富了心理學理論，也為 AI 發展與教育應用帶來了新啟示。",
            "Fan 教授同時簡介了其研究團隊的背景與方法論，強調跨學科合作在認知工具研究中的重要性。其研究方法整合了認知心理學、神經科學與人工智慧技術，從人類日常行為中抽取出強大而實用的思維模式。",
            "本場演講由臺大人工智慧研究中心（AINTU）、清華大學智慧製造與循環經濟研究中心、臺大金融科技研究中心、與臺大資訊工程系共同主辦。",
        ]
    },
    {
        date: "2023-10-05", 
        date2: ["2023年10月5日（四）", "2023年9月26日（二）", "2023年9月27日（三）", "2023年10月3日（二）"],
        title: "2023玉山銀行校園商業競賽",
        name: ["【台灣大學場】", "【政治大學場】", "【成功大學場】", "【清華大學場】"],
        intro: "玉山銀行致力提供多元、便利的數位金融服務及平台，解決顧客金融大小事，並持續發掘顧客隱性需求，提供客製化的解決方案。期盼年輕族群透過競賽，讓創意與產業經驗接軌，共同打造新世代數位金融服務。",
        place: ["台灣大學 管理學院 管一104教室", "政治大學商學院玉山廳", "成功大學 資訊工程系館1樓4203階梯教室", "清華大學115教室（舊育成大樓）"],
        time: "12:00-14:00",
        fileName: "2023玉山銀行校園商業競賽海報.jpg",
        pics: [
            "2023玉山銀行校園商業競賽_活動照片.jpg"
        ],
        paragraph: [
        ],
        link: ["https://forms.gle/Kib9UqkqzXXJJvBa7", "https://forms.gle/qvbEH6PcWKpXvnmu7", "https://forms.gle/A7wGeoit7CEaTnDp9", "https://forms.gle/Vp4vCMmUkYKDwGrW6"],
    },
    {
        "date": "2023-10-06",
        "title": "花有重開日，人無再少年--科技人在職涯的十字路口，如何做出正確的選擇？",
        "intro": "本演講分享科技領袖在快速變動的產業中如何做出職涯選擇，呼應本中心培育兼具技術與決策能力之金融科技人才，並鼓勵跨域學術與產業實踐的融合發展。演講由 Shein US 首席技術長謝居呈博士主講，結合其在Amazon, Etsy 與 Shein 的豐富職涯經歷，深入探討科技人在面對職涯抉擇時如何做出無悔選擇。他將分享自己如何走出舒適圈，擁抱風險與挑戰，並持續透過學術發表與技術領導實現職涯願景，啟發在場的資訊專業人士思考未來發展的方向。",
        "place": "臺大資工系 CSIE R103",
        "fileName": "1006_ChuChengHsieh_lecture.jpg",
        "pics": [
            "chuchenghsieh_pic1.jpg",
            // "chuchenghsieh_pic2.jpg",
            // "chuchenghsieh_pic3.jpg",
            // "chuchenghsieh_pic4.jpg"
        ],
        "paragraph": [
            "2023 年 10 月 6 日，Shein US 首席技術長謝居呈博士受邀至臺大發表演講，主題為「花有重開日，人無再少年——科技人在職涯的十字路口，如何做出正確的選擇？」現場座無虛席，吸引了大量對科技職涯與領導力發展有興趣的學生與業界人士。",
            "謝博士以個人早期職涯經驗為開場，分享他如何受到前輩啟發，勇敢離開舒適圈，選擇了一條少有人走的路。他指出，無論在亞馬遜或後來的職涯中，他始終秉持一個理念：追求「無悔的人生」。",
            "在演講中，他談到科技人如何在職涯中持續前行，包括主動學習、勇於挑戰、積極參與研究與學術發表等。前半段他聚焦在分享於矽谷的職場文化與自身的學習歷程；後半段則開放 Q&A，與聽眾深度對話，現場氣氛熱烈。",
            "他也提到，科技產業變化快速，選擇往往沒有對錯之分，而在於能否誠實面對自己的人生目標與價值。他鼓勵年輕工程師與研究人員多方嘗試，培養持續進步的思維與韌性。",
            "謝居呈博士目前於 Shein US 擔任首席技術長，曾任 Etsy 資訊長，擁有加州大學洛杉磯分校計算機科學博士學位，並活躍於學術界與產業界，發表多篇論文並參與國際會議演講。",
            "本場演講由臺大人工智慧研究中心（AINTU）、臺大金融科技研究中心、與臺大資訊工程系共同主辦。"
        ]
    },
    {
        "date": "2024-06-07",
        "title": "企業的數位與永續轉型",
        "intro": "本演講聚焦企業在數位與永續雙軸轉型中的策略與實踐，呼應本中心推動科技創新與ESG導向金融應用的核心目標，促進產業永續與數位金融融合發展。演講由政治大學謝明華教授主講，深入探討數位時代下企業如何面對挑戰與機遇，並掌握數位技術與ESG趨勢進行雙軸轉型。謝教授具備豐富的產學經驗與跨域專長，將從實務與策略層面分享企業在數位與永續並行轉型下的關鍵思維與實踐方法。",
        "place": "臺大資工系 CSIE R103",
        "fileName": "0607_MingHuaHsieh_lecture.jpg",
        "pics": [
            "minghuahsieh_pic1.jpg",
            // "minghuahsieh_pic2.jpg",
            // "minghuahsieh_pic3.jpg",
            // "minghuahsieh_pic4.jpg"
        ],
        "paragraph": [
            "2024 年 6 月 7 日，政治大學謝明華教授應邀至臺大發表演講，主題為「企業的數位與永續轉型」。本次演講吸引了眾多對企業轉型、ESG 發展與金融科技有興趣的聽眾參與。",
            "謝教授以多年在金融保險與科技領域的研究與實務經驗為基礎，系統性地說明數位時代企業面對的挑戰與機遇。他指出，數位轉型不再只是技術升級，而是關係到整體商業模式與策略方向的重塑。",
            "演講中，他進一步剖析 ESG（環境、社會與公司治理）與永續發展的全球趨勢，並強調企業若能在數位與永續兩條軸線上同步推進，將更能掌握未來競爭優勢與長期韌性。",
            "他也提出數位永續雙軸轉型的架構與策略，強調跨領域整合與領導者思維轉變的關鍵角色。與會者表示從中獲得具體的實務啟發，對企業如何因應未來挑戰有更深刻的理解。",
            "謝明華教授現任政大風險與保險研究中心主任、數位金融創新實驗室執行長，亦擔任多個產業協會創會理事長，長期致力於推動科技與金融的整合發展。",
            "本場演講由臺大人工智慧研究中心（AINTU）、臺大金融科技研究中心、與臺大資訊工程系共同主辦。"
        ]
    },
    {
        date: "2024-07-15", 
        date2: ["7/15(一)", "7/16(二)", "7/19(五)", "7/22(一)", "7/24(三)", "7/26(五)"],
        title: "第9屆經濟部國家產業創新獎說明會",
        intro: "本說明會鼓勵跨界整合與創新應用，正呼應本中心推動產學合作與跨領域金融科技創新，強化我國數位與產業轉型動能。為鼓勵產、政、學、研界跨越領域藩籬，融入人文、服務、系統整合等元素，經濟部特設置國家產業創新獎，以國家級榮譽樹立產業學習典範，表揚產、政、學、研界投入「整合創新」創造附加價值之組織、團隊及個人菁英。",
        place: ["臺灣科學工業園區科學工業同業公會中科園區702會議室 <台中市大雅區中科路6號7樓>", 
            "臺大醫院國際會議中心402AB <台北市中正區徐州路2號4樓>",
            "高雄軟體科學園區401中型會議室 <高雄市前鎮區復興四路12號>",
            "嘉義產業創新研發中心服務大樓3樓小型會議室 <嘉義市西區博愛路二段569號服務大樓3樓>",
            "臺南文化創意產業園區金龍展演廳 <臺南市東區北門路二段16號>",
            "臺灣科學工業園區科學工業同業公會竹科園區202會議室 <新竹科學園區展業一路2號2樓>",
        ],
        area: ["臺中", "臺北(同步視訊)", "高雄", "嘉義", "臺南", "新竹"],
        time: ["14:00-16:00", "09:30-11:30", "14:00-16:00", "14:00-16:00", "14:00-16:00", "14:00-16:00"],
        fileName: ["第9屆經濟部國家產業創新獎簡章.pdf", "第9屆經濟部國家產業創新獎說明會報名表.docx"],
        pic: "第9屆經濟部國家產業創新獎圖片.png",
        QRcode: "第9屆經濟部國家產業創新獎QR code.jpg",
    },
    {
        "date": "2024-10-17",
        "title": "第27屆東方口語語音資料庫協調暨標準化國際研討會 (O-COCOSDA 2024)",
        "intro": "本研討會聚焦於語音資料庫與語音技術標準化，所涵蓋的聲音身分驗證、AI 客服安全性提升與聲紋比對等主題，與本中心推動語音技術於金融交易安全與智能客服系統之應用密切相關。第27屆東方口語語音資料庫協調暨標準化國際研討會（O-COCOSDA 2024）將於2024年10月17日至19日於新竹舉行，由國立陽明交通大學主辦。本研討會致力於促進東方語言語音資料庫之建立、應用與評估技術之標準化，提供產學研交流合作的重要平台，邀請全球語音技術研究者與產業夥伴共同參與。",
        "place": "國立陽明交通大學（新竹）",
        "fileName": "1017_OCOCOSDA2024.jpg",
        "pics": [
            "ococosda2024_pic1.jpg",
            // "ococosda2024_pic2.jpg",
            // "ococosda2024_pic3.jpg",
            // "ococosda2024_pic4.jpg"
        ],
        "paragraph": [
            "第27屆東方口語語音資料庫協調暨標準化國際研討會（O-COCOSDA 2024）預定於2024年10月17日至19日舉行，地點為新竹，由國立陽明交通大學主辦，將以實體形式進行，歡迎各界踴躍參與。",
            "O-COCOSDA 為 COCOSDA 的東方分支，創立於1997年，旨在推動東方語系語音資料庫的建立、應用與評估技術的標準化。研討會提供學術界與產業界在語音輸入輸出系統的國際合作平台，並鼓勵分享語音技術的最新研究成果。",
            "自1997年以來，O-COCOSDA 已於多個亞洲國家舉辦，包括香港、日本、中國、韓國、泰國、新加坡、印度、馬來西亞、越南、緬甸與台灣等地。2024年大會再次回到台灣，象徵本地語音研究社群在國際上的活躍角色與貢獻。",
            "研討會主題涵蓋語音語料庫的開發、語音辨識與合成系統的評估方法、語言資源標準化，以及跨語言語音研究等議題。主辦單位熱情邀請學者、實務工作者、業界代表與贊助單位共襄盛舉，促進跨界合作與知識共享。",
            "本研討會由社團法人中華民國計算語言學學會主辦，並由臺大金融科技研究中心、中央研究院、陽明交大產學創新研究學院共同協辦。"
        ],
        link: ["https://ococosda2024.github.io/"]
    },
    {
        "date": "2025-06-10",
        "title": "2025 AI金融科技發展論壇",
        "intro": "在數位轉型與 AI 技術推動下，全球金融產業正面臨劇烈重塑。2025 AI金融科技發展論壇聚焦 AI 在金融創新、風險控管、普惠金融與創投領域的應用與發展，集結政策制定者、產業專家、學研單位及新創企業，共同探索金融科技的新典範，打造更具韌性與普及性的金融服務體系。",
        "place": "臺灣大學第二活動中心",
        "fileName": "0610_AIFinTechForum2025.png",
        "pics": [
            "aiforum2025_pic1.png",
            "aiforum2025_pic2.jpg",
            // "aiforum2025_pic3.jpg",
            // "aiforum2025_pic4.jpg"
        ],
        "paragraph": [
            "2025 年 6 月 10 日，由 AI 金融科技協會主辦、臺大金融科技研究中心協辦的「2025 AI金融科技發展論壇」即將盛大舉行。本次論壇聚焦 AI 如何驅動金融產業變革，推動普惠金融與創投生態圈發展。",
            "在全球數位轉型加速與政策變動頻繁的情境下，金融業正面臨資金流動複雜化與風險控管挑戰。AI 在資料處理、風控技術與精準金融服務上的應用，成為重塑金融模式的關鍵力量。",
            "本次活動亦將關注如何運用 AI 技術降低中小企業與弱勢族群的融資門檻，促進資源公平分配，實現普惠金融目標，建立更具包容性與創新力的金融生態體系。",
            "主辦: AI金融科技協會",
            "協辦: 臺大金融科技研究中心",
        ],
        link: ["https://www.aifintechtw.com/ai-forum"]
    },
    {
        "date": "2026-03-31",
        "title": "2026 RWA Forum｜資產代幣化的發展與制度化路徑論壇",
        "intro": "在全球金融體系邁向數位化與制度創新的關鍵階段，現實世界資產代幣化（Real-World Assets, RWA）正逐步從概念驗證（PoC）邁向制度化試辦與實際應用，成為連結傳統資本市場、金融基礎建設與區塊鏈技術的重要橋樑。本論壇由數位資產發展研究中心（DADRC）主辦，臺大金融科技研究中心共同協辦，集結國際 RWA 平台、機構級技術供應商、專業顧問與台灣監理與學研單位，共同探討 RWA 如何在可監理前提下落地，從試辦走向制度化資本市場。",
        "place": "政大公企中心 A2 國際會議廳 (台灣台北市大安區金華街187號 2F)",
        "time": "13:00 - 16:30",
        "fileName": "0331_RWAForum2026_poster.jpg",
        "pics": [
            "rwaforum2026_group.jpg",
            "rwaforum2026_pic1.jpg",
            "rwaforum2026_pic2.jpg",
            "rwaforum2026_pic3.jpg",
        ],
        "paragraph": [
            "2026 年 3 月 31 日，由數位資產發展研究中心（DADRC）主辦，臺大金融科技研究中心、臺灣亞太監理科技協會、Deloitte 勤業眾信、Zodia Custody、臺灣區塊鏈愛好者協會、資策會數轉院金科中心、政大風險與保險研究中心共同協辦的「2026 RWA Forum｜資產代幣化的發展與制度化路徑論壇」於政大公企中心國際會議廳盛大舉行，吸引產官學研各界代表齊聚一堂。",
            "國際市場方面，包含 Nasdaq 在內的主要資本市場機構，已開始積極評估並推動股票與金融資產的代幣化應用；監理機構亦同步就相關制度提出回應與政策方向，顯示全球資本市場正迎來一波交易與結算模式的結構性轉變。在台灣，金融監督管理委員會已就「金融建言白皮書」召開多次研商會議，並針對推動現實世界資產（RWA）代幣化市場基礎建設提出具體政策討論方向；相關周邊單位亦已成立「RWA 代幣平台專案小組」，規劃建置集中式平台，以逐步建構具制度性、可監理、可擴展的 RWA 生態體系。",
            "論壇議程涵蓋國際 RWA 平台實務、機構級 RWA 解決方案的平台架構關鍵考量、機構級區塊鏈跨機構協作與隱私保護，以及顧問視角下的法遵、會計與風險管理等主題，並以綜合座談「RWA 如何從試辦走向制度化資本市場」為壓軸。講者陣容包括 APEX Digital 亞太區銷售總監 Vince Turcotte、BSOS 共同創辦人暨執行長 Daniel Huang、Canton Foundation 生態系經理 Teagan Buckley，以及勤業眾信 Deloitte 資深執行副總經理陳鴻棋等重量級嘉賓。",
            "隨著實體資產逐步導入區塊鏈架構，全球實務正從封閉式私鏈，走向「公鏈結合治理與合規層」的新模式。本論壇透過國際平台、專業顧問與台灣金融機構的實務經驗分享，具體描繪 RWA 在可監理前提下落地的路徑；臺大金融科技研究中心亦以協辦角色，持續推動學界與產業、監理單位的對話，為台灣資本市場迎向代幣化轉型貢獻研究能量。",
            "主辦：DADRC 數位資產發展研究中心",
            "協辦：臺灣亞太監理科技協會、Deloitte 勤業眾信、Zodia Custody、臺灣區塊鏈愛好者協會、資策會數轉院金科中心、台大金融科技研究中心、政大風險與保險研究中心",
            "贊助：Apex Group、BSOS 灣谷科技、Canton Network",
        ],
        link: ["https://www.accupass.com/event/2601210624491420004613"]
    },
    {
        "date": "2026-05-15",
        "title": "AI 論文分享交流會（AI Research Exchange Workshop）",
        "intro": "在 AI 技術快速更迭的時代，掌握前沿趨勢是研究者的核心競爭力。本活動由臺灣大學人工智慧研究中心（AINTU）主辦、臺大金融科技研究中心協辦，邀請 2 位資深學者進行專題演講，並由 12 位頂尖國際會議論文作者分享研究精華與心得，搭配海報展示時段促進跨校、跨域交流與合作。",
        "place": "臺灣大學霖澤館一樓國際會議廳",
        "time": "09:00 - 17:00",
        "fileName": "0515_AIResearchExchangeWorkshop_poster.png",
        "pics": [
            "aiworkshop2026_pic1.jpg",
            "aiworkshop2026_pic2.jpg",
            "aiworkshop2026_pic3.jpg",
            "aiworkshop2026_pic4.jpg",
        ],
        "paragraph": [
            "2026 年 5 月 15 日，由臺灣大學人工智慧研究中心（AINTU）主辦、臺大金融科技研究中心協辦的「AI 論文分享交流會（AI Research Exchange Workshop）」將於臺大霖澤館一樓國際會議廳舉行，全程免費、名額有限。",
            "在 AI 技術快速更迭的時代，掌握前沿趨勢是研究者的核心競爭力。臺灣大學人工智慧研究中心 (AINTU) 特別舉辦 「AI 論文分享交流會」，旨在透過AI領域頂尖國際會議的論文分享與跨領域對話，協助研究人員高效接軌全球技術進展。本次活動特別邀請 2 位資深學者分享珍貴的研究歷程，並集結 12 位頂會論文作者現身說法，解析研究精華與心得。同時規劃海報展示時段，讓參與者能與作者面對面深度交流，開啟跨校、跨域合作的無限可能。無論您是追求卓越的研究生或工程師，這都是您擴展專業人脈、洞察技術脈動的最佳機會。活動全程免費，名額有限，誠摯邀請各界 AI 精英踴躍報名參加！",
            "",
            "主辦：臺灣大學人工智慧研究中心（AINTU）",
            "協辦：臺大金融科技研究中心",
        ],
        link: [
            "https://sites.google.com/view/ai-research-exchange-workshop",
            "https://ai.ntu.edu.tw/%e8%87%ba%e5%a4%a7ai%e4%b8%ad%e5%bf%83%e4%b8%bb%e8%be%a6%e3%80%8cai-%e8%ab%96%e6%96%87%e5%88%86%e4%ba%ab%e4%ba%a4%e6%b5%81%e6%9c%83-ai-research-exchange-workshop%e3%80%8d/",
            "https://drive.google.com/drive/folders/15RxixI_zERGkGzc18RBhZ-WKTn3GdUGi",
            "https://sites.google.com/view/ai-research-exchange-workshop/%E6%B4%BB%E5%8B%95%E6%B5%B7%E5%A0%B1%E8%88%87%E7%B0%A1%E5%A0%B1",
        ],
    }
]

export { ACTIVITIES }